import Enums from 'utils/EnumsManager';

const { DROPZONES, FieldTypes } = Enums;
const { SIDER } = DROPZONES;

class Column {
  constructor({
    id = '',
    name = '',
    type = FieldTypes.TextInput,
    label = '',
    disabled = false,
    belongTo = SIDER,
    onDrop = false,
    actions = [],
    lookupKey = '',
    fieldRestricted = false,
    fieldDeleted = false,
  }) {
    this._id = id;
    // Notes: name is primary key
    this._name = name;
    this._type = type;
    this._label = label;
    this._disabled = disabled;
    this._belongTo = belongTo;
    this._onDrop = onDrop;
    this._actions = actions;
    this._lookupKey = lookupKey;
    this._fieldRestricted = fieldRestricted;
    this._fieldDeleted = fieldDeleted
  }

  static isValid() {
    return false;
  }

  static toApi() {
    return {};
  }

  /* getters and setters */
  // id
  get id() {
    return this._id;
  }
  set id(val) {
    this._id = val;
  }
  // belongTo
  get belongTo() {
    return this._belongTo;
  }
  set belongTo(val) {
    if (!(val in DROPZONES)) {
      throw new Error('Fail to set "belongTo". No such Dropzone type.');
    }
    this._belongTo = val;
  }
  // disabled
  get disabled() {
    return this._disabled;
  }
  set disabled(val) {
    this._disabled = !!val;
  }
  // label
  get label() {
    return this._label;
  }
  set label(val) {
    this._label = val;
  }
  // type
  get type() {
    return this._type;
  }
  set type(val) {
    this._type = val;
  }
  // name
  get name() {
    return this._name;
  }
  set name(val) {
    this._name = val;
  }
  // onDrop
  // @description: set record onDrop to show modal if record dropped in Group or Aggregate zones.
  get onDrop() {
    return this._onDrop;
  }
  set onDrop(val) {
    this._onDrop = val;
  }
  // actions
  // @description: set extra actions on record based on their zone attributes.
  get actions() {
    return this._actions;
  }
  set actions(val) {
    this._actions = val;
  }
  // lookupKey
  // @description: lookup key that stores actual value
  get lookupKey() {
    return this._lookupKey;
  }
  set lookupKey(val) {
    this._lookupKey = val;
  }
  get fieldRestricted() {
    return this._fieldRestricted;
  }
  set fieldRestricted(val) {
    this._fieldRestricted = val;
  }
  get fieldDeleted() {
    return this._fieldDeleted;
  }
  set fieldDeleted(val) {
    this._fieldDeleted = val;
  }
}

export default Column;



// WEBPACK FOOTER //
// ./src/views/ReportSetup/utils/Column.js